var map = {
	"./africa/lobby.layout.vue": [
		"8FMg",
		1
	],
	"./club-soft/lobby.layout.vue": [
		"tzBk",
		0
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "ptBt";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./skins/xkiosk/layouts/lobby lazy ^\.\/.*\/lobby\.layout\.vue$
// module id = ptBt
// module chunks = 37